<ng-container *transloco="let t">
  <div class="form-status" [ngClass]="styleClass">
    <div
      class="invalid"
      [class.show]="display$ | async"
      [pTooltip]="title$ | async"
      [showDelay]="250"
      tooltipPosition="bottom"
      [escape]="false"
      [hideDelay]="250"
    >
      {{ label$ | async }}
    </div>
  </div>
</ng-container>
